import config from '../config'
import { ExperimentGo } from '../generated/graphql'
import { gtag } from './gtag'

export const setExperiments = (experiments: ExperimentGo[]) => {
  if (!experiments || !config.ga?.trackingId) return
  gtag('config', config.ga?.trackingId, { experiments })
}
